import People from './People';
import PeopleDetail from './PeopleDetail';
import EditPeople from './EditPeople';
import EditUnitLink from './EditUnitLink';
import ApprovalsHistory from './ApprovalsHistory';

export {People, PeopleDetail, EditPeople, EditUnitLink, ApprovalsHistory};
